import { combineReducers } from '@reduxjs/toolkit';

import orderReducer from './order/order.slice';

const reducers = combineReducers({
  order: orderReducer,
});

export default reducers;
